import config from "../config"

const contact = (msg, cb) => {
  fetch(`${config.CONTACT_URL}`, { method: 'post', body: msg })
    .then(res => cb(res.ok))
    .catch(() => cb(false))
}

export { contact }